<template>
  <div ref="wrapper" class="dialog-container" :class="wrapperClasses">
    <slot name="toggle-button" :handleToggle="toggleModal">
      <button @click="toggleModal" :class="buttonClasses">
        {{ buttonTitle }}
      </button>
    </slot>
    <dialog
      ref="dialog"
      class="dialog-component"
      :class="dialogClass"
      @click="handleDialogClick"
      @close="closeDialog">
      <form ref="form" method="dialog" @change="onChangeHandler">
        <slot></slot>
      </form>
    </dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    buttonTitle: {
      type: String,
      default: 'Click'
    },
    buttonClasses: {
      type: [String, Object, Array],
      default: ''
    },
    wrapperClasses: {
      type: [String, Object, Array],
      default: ''
    },
    dialogClass: {
      type: [String, Object, Array],
      default: ''
    },
    onDialogClose: {
      type: Function,
      default: () => {}
    },
    onDialogChange: {
      type: Function,
      default: (e) => {}
    },
    isOpen: {
      type: Boolean
    },
    leftOffset: {
      type: Number,
      default: 20
    }
  },
  mounted () {
    if (this.isOpen) {
      this.toggleModal()
    }
  },
  methods: {
    onChangeHandler (e) {
      // logic to run when form change
      this.onDialogChange(e, this.toggleModal)
    },
    closeDialog (e) {
      // logic to run when dialog close
      this.onDialogClose(e, this.toggleModal)
    },
    toggleModal () {
      const dialog = this.$refs.dialog
      if (dialog.open) {
        dialog.close()
        return
      }
      const wrapper = this.$refs.wrapper
      dialog.style.top = wrapper.getBoundingClientRect().bottom + 'px'
      dialog.style.left =
        wrapper.getBoundingClientRect().left - this.leftOffset + 'px'
      dialog.showModal()
    },
    handleDialogClick (e) {
      const dialog = this.$refs.dialog
      if (e.target == dialog) {
        dialog.close()
      }
    }
  }
}
</script>

<style scoped>
.dialog-component {
  border: 0;
  padding: 20px;
  margin: 0;
}
.dialog-component::backdrop {
  background-color: transparent;
}
</style>
